import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { IPosterOrder, IPosterOrderItem } from '../../../../../../../../common/common-interfaces/poster-order';
import { Subscription } from 'rxjs';
import { countryCodesUpperCase } from '../../../../../../../../common/common-types/country';
import { availableSkuInfoByPosterType } from '../../../../../../../../common/common-helpers/sku';

@Component({
    selector: 'poster-order',
    templateUrl: './poster-order.component.html',
    styleUrls: ['./poster-order.component.scss'],
    standalone: false
})
export class PosterOrderComponent {
  order: IPosterOrder;
  orderId: string;
  availableSkuInfoByPosterType = availableSkuInfoByPosterType;
  availableCountryCodes = countryCodesUpperCase;
  orderItemsById: { [id: string]: IPosterOrderItem } = {};
  private paramsSubscription: Subscription | null = null;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

  }

  async ngOnInit() {
    this.paramsSubscription = this.route.params.subscribe(async (params) => {
      if (params['id']) {
        this.orderId = params['id'];
        await this.fetchOrder();
      }
    });
  }

  async save() {
    await this.api.store().patch(`/poster-orders/${this.order._id}`, this.order);
  }

  async fetchOrder() {
    this.order = await this.api.store().get<any>(`/poster-orders/${this.orderId}`);
    for (let orderItem of this.order.items) {
      this.orderItemsById[orderItem.identifier] = orderItem;
    }
  }

  async cancelOrder() {
    await this.api.store().post(`/poster-orders/${this.order._id}/cancel`, this.order);
    this.order.status = 'CANCELLED';
  }


  async updateProcessingFee() {
    await this.api.admin().post(`/poster-orders/${this.order._id}/update-processing-fee`, this.order.processingFee);
    await this.fetchOrder();
  }

  isEditable() {
    return ['PENDING', 'READY'].includes(this.order.status);
  }


  ngOnDestroy(): void {
    (this.paramsSubscription as Subscription).unsubscribe();

  }



}


